/**
 * ``<RequiresRbacManager>`` — route gate for the Roles & permissions screen.
 * Admits platform super-admins AND company (hr_admin) admins; redirects
 * everyone else. Belt to the server-side scoping suspenders.
 */
import { Navigate } from "react-router-dom";

import { Skeleton } from "@/components/ui/skeleton";
import { canManageRbac, useRbacScope } from "@/lib/rbac";

export function RequiresRbacManager({ children }: { children: React.ReactNode }) {
  const { data, isLoading } = useRbacScope();

  if (isLoading || !data) {
    return (
      <div className="space-y-4 p-6">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  if (!canManageRbac(data)) {
    return <Navigate to="/settings" replace />;
  }

  return <>{children}</>;
}
